import store from "store";

export default {
    get: () => {
        if (!process.env.WEBPACK) return;
        const value = store.get("echoSound") || 0;
        return !!+value;
    },
    toggle: function (this: { forceUpdate: () => void }) {
        if (!process.env.WEBPACK) return;
        const value = +(store.get("echoSound") || 0);
        store.set("echoSound", value === 1 ? 0 : 1);
        this.forceUpdate();
    },
};
